import {EnvironmentConstants} from './services/environment.constants';

export class MSTIConfiguration {
    public static environment;
    public static baseUIPath = '';
    public static sessionExtenderUrl;
    public static readonly lookupsScope = 'sti';
    public static constants: EnvironmentConstants = new EnvironmentConstants();
}
